module.exports = __webpack_public_path__ + "img/hr-heated-corner-down-left-1.fb80ec94.png";